var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25.8px",
    height: "25.8px",
    viewBox: "0 0 25.8 25.8",
    style: {
      enableBackground: "new 0 0 25.8 25.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.2,17.6c-0.2,0-0.4,0.2-0.4,0.4v2H6v-2c0-0.2-0.2-0.4-0.4-0.4S5.2,17.8,5.2,18v2.1c0,0.4,0.4,0.7,0.7,0.7 h14c0.4,0,0.7-0.4,0.7-0.7V18C20.6,17.8,20.4,17.6,20.2,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,17.9C12.6,17.9,12.6,17.9,12.6,17.9c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0,0,0,0,0,0l4.2-4.1 c0.1-0.1,0.2-0.4,0-0.5c-0.1-0.1-0.4-0.2-0.5,0l-3.6,3.5V5.4c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4v11.3L9,13.2 c-0.1-0.1-0.4-0.1-0.5,0c-0.1,0.1-0.1,0.4,0,0.5L12.6,17.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dd1932e5d0387de860ecdc8e5a565d23.svg";
export { ForwardRef as ReactComponent };